import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { FlatTreeControl } from '@angular/cdk/tree';
import { ChangeDetectorRef, Component, Input, OnInit, Optional, SimpleChange, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { VhQueryAutoWeb } from 'vhautowebdb'; 
// import { ChooseIconComponent } from 'vhobjects-admin';
import { ChooseIconComponent } from 'vhobjects-service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { FunctionService  } from 'vhobjects-service';

/**
 * Phần mở rộng của menu
 */
interface FlatNode {
  expandable: boolean;
  name: string;
  level: number;
  _id: string;
  link_page?: string;
  link_website?: string;
  link_url?: string;
  subData?: any;
  icon?: string;
  group?: string,
  item?: any,
  groupParent?: string,
  id_page_category?: string;
  id_freeblock?: string;
  type?: string;
  is_scroll?: boolean;
}
/**
 * Dạng data của 1 menu khi truyền đi và nhận được khi return
 */
interface MenuNode {
  name: string;
  children?: MenuNode[];
  group?: string,
  _id: string;
  subData?: any;
  item?: any,
  link_page?: string;
  link_website?: string;
  icon?: string;
  link_url?: string;
  is_scroll?: boolean;
  groupParent?: string,
  id_page_category?: string;
  id_freeblock?: string;
  type?: string;
}

@Component({
  selector: 'atw-menu-vertical-admin',
  templateUrl: './menu-vertical-admin.component.html',
  styleUrls: ['./menu-vertical-admin.component.scss']
})

export class AtwMenuVerticalAdmin implements OnInit {
  @Input() data: any; // dữ liệu của object từ block truyền vào gồm {_id, component, desktop_position, mobile_position, x, y, rows, cols, z_index}
  @Input() type: any;
  dataReturned: any = [];
  visibleSub = {}; // biến này xác định sub-menu được ẩn hay hiện.
  dataAddMenu = {};  // biến này lưu giá trị khi thêm menu cha
  dataEditMenu = {}; // biến này lưu giá trị khi sửa menu cha
  dataAddSubMenu = {};// biến này lưu giá trị khi thêm menu con
  dataEditSubMenu = {};// biến này lưu giá trị khi sưa menu con
  isOpenAddMenu: boolean = false; // biến này lưu trạng thái mở form thêm menu
  isOpenEditMenu: boolean = false;// biến này lưu trạng thái mở form sửa menu
  isOpenAddFormSubMenu: boolean = false; // biến này lưu trạng thái mở form thêm submenu
  isOpenEditFormSubMenu: boolean = false;// biến này lưu trạng thái mở form sửa submenu
  isCallingCate: boolean = false;
  checkExistIdCategory: boolean = false;
  dataLoaded: boolean = false; // Biến cờ để kiểm tra xem dữ liệu đã được tải hay chưa

  constructor(
    public functionService: FunctionService,
    private vhQueryAutoWeb: VhQueryAutoWeb,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef,
    @Optional() private modal: NzModalRef // Thêm @Optional() vào NzModalRef
  ) {
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.getDataCate();
    }, 200);

    this.getCommonData();
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log('changes', changes);
    if (changes.data && !changes.data.firstChange) {
      this.getCommonData();
    }
  }

  ngAfterViewChecked() {
    if (this.isCallingCate) {
      this.getDataCate();
      this.ref.detectChanges();
      this.isCallingCate = false;
    }
  }

  /**
   * Lấy dữ liệu từ CommonDatas
   */
  getCommonData() {
    if (this.dataLoaded) return; // Nếu dữ liệu đã được tải, không gọi API nữa
    this.vhQueryAutoWeb.getCommonDatas_byFields({ id_object: { $eq: this.data._id } }, {}, {}, 0)
      .then((products: any) => {
        // console.log('getCommonDatas_byFields', products);
        this.dataReturned = products[0];
        this.dataSource.data = products[0].data;
        this.dataLoaded = true;

        console.log(products);
        
      })
  }
  
  // Phương thức đóng modal
  closeModal(): void {
    this.modal.close();
  }
  


  //---------------------------------------------- CÁC THAO TÁC XỬ LÝ FORM MENU CHA -----------------------------------------\\
  
  /**
   * Mở form thêm menu
   */
  openAddMenuItem() {
    this.isOpenAddMenu = true;
    this.dataAddMenu = { menu: { type: 'link-page', group: 'link', groups: this.data['groups'] || ["link", "category", "pop-up"] } };
  }
  /**
   * Đóng form thêm menu
   */
  isCancelFormAddMenu(event) {
    this.isOpenAddMenu = event;
  }

  /**
   * Lấy từ liệu từ form thêm menu
   */
  getDataFormAdd(event) {
    this.dataSource.data = [...this.dataSource.data, event.menu];
    this.updateValueMenu({ data: this.dataSource.data });
  }

  /**
   * Kiểm tra là menu hay submenu và mở form sửa menu
   */
  openEdit(item) {
    if (item.level === 0) {
      this.openEditMenuItem(item)
    } else {
      this.openEditSubMenuItem(item)
    }
  }

  /**
   * Mở form sửa menu
   */
  openEditMenuItem(item) {

    let temp = {...item}; // biến tạm thời để lưu menu item để khi edit thì không edit tực tiếp lên tree
    this.isOpenEditMenu = true;
    this.dataEditMenu = {
      item: temp,
      type: temp.type,
      groups: this.data['groups'] || ["link", "category", "pop-up"]
    }
  }
  /**
   * Đóng form sửa menu
   */
  isCancleFormEditMenu(event) {
    this.isOpenEditMenu = event
  }
  /**
   * Lấy dữ từ form chỉnh sửa menu
   */
  getValueFormEditMenu(event) {
    this.dataSource.data = this.dataSource.data.map((item) => {
      if (event.item._id !== item._id) {
        return item;
      }
      return {
        ...item,
        ...event.item,
        link_page: event.item.link_page ? event.item.link_page : undefined,
        link_url: event.item.link_url ? event.item.link_url : undefined,
        link_website: event.item.link_website ? event.item.link_website : undefined,
        icon: event.item.icon ? event.item.icon : undefined,
        children: (event.item.group != item.group ? [] : item.children),
        subData: (event.item.group != 'category' && item.group == 'category' ? [] : item.subData),
        is_scroll: event.item.is_scroll 
      }
    });


    // Đồng bộ dữ liệu giữa cây mat-tree và data thực hiện ở file ts
    this.dataSource.data = this.dataSource.data;
    this.updateValueMenu({ data: this.dataSource.data })
  }


  //------------------------------------------------- CÁC THAO TÁC XỬ LÝ FORM SUBMENU ---------------------------------------\\
    
  /**
   * Mở form thêm submenu
   */
  openAddSubMenuItem(item) {
    this.isOpenAddFormSubMenu = true;
    this.checkExistIdCategory = item.id_page_category ? true : false;
    // Thêm dữ liệu sub menu để truyền vao form thêm submenu
    this.dataAddSubMenu = {
      item: item,
      childMenu: {
        type: item.id_page_category ? 'category' : (item.id_freeblock ? 'block' : 'link-page'),
        groupParent: item.group,
        is_scroll: item.subData?.[0]?.is_scroll || false,
      }
    }
  }
  /**
   * Đóng form thêm submenu
   */
  isCancelFormAddSub(event) {
    this.isOpenAddFormSubMenu = event;
  }
  /**
   * Lấy từ liệu từ form thêm submenu
   */
  getValueFormAddSub(event) {
    const childMenu = event.childMenu; // note hien 
    // get node trong tree
    const result = this.deepSearch(this.dataSource.data, event.item._id)
    // check group của node và thêm vào data tương ứng
    if (event.item.group === "category") {
      result.subData = childMenu.listPageCategorySelected.length > 0 ? [childMenu] : event.subData
    } else {
      // Kiểm tra menu có children?
      if (result.children && result.children.length > 0) {
        // Nếu có sẽ thêm menu con vào menu cha
        result.children.push(childMenu)
      } else {
        // Không có sẽ tạo children[]
        result.children = [childMenu]
      }
    } 

    // Đồng bộ dữ liệu giữa mat-tree và file ts
    this.dataSource.data = this.dataSource.data;
    this.updateValueMenu({ data: this.dataSource.data });
  }

  /**
   * Mở form sửa submenu
   */
  openEditSubMenuItem(item) {
    let temp = {...item}; // biến tạm thời để lưu menu item để khi edit thì không edit tực tiếp lên tree
    this.isOpenEditFormSubMenu = true;
    this.dataEditSubMenu = {
      childMenu: temp,
      // index: index,
      type: temp.type
    }
  }
  /**
   * Đóng form sửa submenu
   */
  isCancleFormEditSub(event) {
    this.isOpenEditFormSubMenu = event;
  }
  /**
   * Lấy từ liệu từ form submenu
   */
  getValueFormEditSub(event) {
    const object = this.deepSearch(this.dataSource.data, event.childMenu._id)
    object.type = event.childMenu.type;
    object.icon = event.childMenu.icon;
    object.name = event.childMenu.name;
    // assign all field start with name_
    for (let key in event.childMenu) {
      if (key.includes('name_')) {
        object[key] = event.childMenu[key];
      }
    }
    object.link_page = event.childMenu.link_page;
    object.link_url = event.childMenu.link_url;
    object.link_website = event.childMenu.link_website;
    this.dataSource.data = this.dataSource.data; // dòng này làm cho menu bị đóng khi chọn/xóa icon
    this.updateValueMenu({ data: this.dataSource.data })
  }


  //------------------------------------------------- CÁC THAO TÁC XỬ LÝ TREE ---------------------------------------\\

  /**
   * Hàm duyệt cây
   */
  loopTree(array, is_scroll) {
    for (let i = 0; i < array.length; i++) {
      array[i].group = "category"
      array[i].is_scroll = is_scroll
      if (array[i].children && array[i].children.length > 0) {
        this.loopTree(array[i].children, is_scroll);
      }
    }
    return array;
  }

  /**
   * Hàm tìm kiếm node tree
   */
  deepSearch(array, targetId, type = "") {
    for (let i = 0; i < array.length; i++) {
      if (array[i]._id === targetId) {
        return array[i];
      }
      if (array[i].children && array[i].children.length > 0) {
        const result = this.deepSearch(array[i].children, targetId, type);
        if (!!result) {
          if (type === "delete") {
            return array[i]
          }
          return result;
        }
      }
    }
    return null;
  }

  /**
   * Lấy giá trị true để gọi lại hàm getCate khi thêm sub category
   */
  getDataCategoryAgain(event) {
    this.isCallingCate = event;
  }

  /**
   * Lấy cây danh mục hiển thị
   */
  getDataCate() {
    this.dataSource.data?.forEach((cates) => {
      if (cates.subData) {
        cates.subData.map((cate) => {
          if (cate.listPageCategorySelected) {
            this.vhQueryAutoWeb.getCategoryTree_byIdCategoryArray(cate.listPageCategorySelected)
              .then((response: any) => {
                console.log(response);
                if (response.vcode === 0) {
                  // set danh mục vào group category
                  const dataRes = response.data
                  /**
                   *  Hàm này sắp xếp lại danh mục theo thứ tự đã chọn
                   * ví dụ cate.listPageCategorySelected = ['123', '456', '789']
                   * dataRes = [{_id: '789'}, {_id: '123'}, {_id: '456'}]
                   * sau khi sắp xếp sẽ là [{_id: '123'}, {_id: '456'}, {_id: '789'}]
                   */
                  const compareFunction = (a: any, b: any) => {
                    return cate.listPageCategorySelected.indexOf(a._id) - cate.listPageCategorySelected.indexOf(b._id);
                  };
                  dataRes.sort(compareFunction)
                  cates.children = this.loopTree(dataRes, cate.is_scroll)
                  this.updateValueMenu({ data: this.dataSource.data });
                  this.dataSource.data = this.dataSource.data
                }
              })
              .catch((error: any) => {
                
              });
          }
          else {
            cate.children = []
            this.updateValueMenu({ data: this.dataSource.data });
            this.dataSource.data = this.dataSource.data
          }
        });
      }
    })

  }


  /**
   * Xử lí data get về từ mat-tree
   */
  private _transformer = (node: MenuNode, level: number) => {
    const result = {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      group: node.group,
      subData: node.subData,
      link_page: node.link_page,
      id_page_category: node.id_page_category,
      id_freeblock: node.id_freeblock,
      link_website: node.link_website,
      icon: node.icon,
      link_url: node.link_url,
      type: node.type,
      _id: node._id
    };
  
    // Assign all fields that start with 'name'
    for (const key in node) {
      if (key.startsWith('name')) {
        result[key] = node[key];
      }
    }
  
    return result;
  };

  treeControl = new FlatTreeControl<FlatNode>(
    (node) => node.level,
    (node) => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: FlatNode) => {
    return node.level === 0 ? true : node.expandable
  };

  /**
   * Tìm node cha của mat-tree (Sử dụng hàm riêng)
   */
  findParrentNode(menu) {
    let id = ""
    const { treeControl } = this;
    const currentLevel = treeControl.getLevel(menu);

    // level node !== 0 thì tìm node cha bằng 0 thì lấy chính nó
    if (currentLevel != 0) {
      const index = treeControl.dataNodes.indexOf(menu) - 1;

      for (let i = index; i >= 0; i--) {
        const currentNode = treeControl.dataNodes[i];

        if (treeControl.getLevel(currentNode) < currentLevel) {
          id = currentNode?._id
          break;
        }
      }
    }
    return { currentLevel, id }
  }

  // ----------------------------------------------- CÁC THAO TÁC XỬ LÝ XÓA MENU CHA -----------------------------------\\
  
  /**
   * Xóa menu-item
   */
  removeMenuItem(menu) {
    const idChildren = menu._id
    // tim kiem node trong mat-tree
    const nodeParrent = this.findParrentNode(menu);
    let idParent = menu._id
    // Nếu menu là menu cấp 0 thì sẽ xoá tất cả /
    if (nodeParrent.currentLevel == 0) {
      const arr = this.dataSource.data.filter(item => item._id !== idParent)
      this.dataSource.data = arr
    } else {
      // Tìm đến menu cha của menu đó và xoá
      let result = this.deepSearch(this.dataSource.data, nodeParrent.id);
      let arr = result.children.filter((item) => item._id !== idChildren)
      result.children = arr
    }
    this.dataSource.data = this.dataSource.data
    // thực hiện xóa menu cha và menu con
    this.updateValueMenu({ data: this.dataSource.data })
  }


  // ---------------------------------------------- CÁC THAO TÁC CHUNG CỦA MENU VÀ SUBMENU --------------------------------------\\

  /**
   * Hàm thêm icon
   */
  addIconToParent(menu) {
    // Mở form chọn icon
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });
    // Update icon vào các menu
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        menu['icon'] = result.icon;
      }
      const event = {}
      if (menu.level !== 0) {
        event['childMenu'] = menu;
        this.getValueFormEditSub(event);
      }
      else {
        event['item'] = menu;
        this.getValueFormEditMenu(event);
      }
    });
  }

  /**
   * Hàm xóa icon
   */
  deleteIcon(menu) {
    if (menu.icon) {
      delete menu['icon']
    }
    const event = {}
    if (menu.level !== 0) {
      event['childMenu'] = menu;
      this.getValueFormEditSub(event);
    }
    else {
      event['item'] = menu;
      this.getValueFormEditMenu(event);

    }
  }
  
  /**
   * Hàm cập nhật lên database
   */
  updateValueMenu(value) {
    this.vhQueryAutoWeb.updateCommonData(this.dataReturned._id, value)
      .then((rsp: any) => {
        if (rsp.vcode === 0) {
          
        }
      }, error => {
        
      })
  }

  /** 
  * Hàm thực hiện xử lý khi thay đổi vị trí của menu__item
  *
  * @param event
  */
  cdkDropListDropped(event: CdkDragDrop<any[]>) {
    
    moveItemInArray(this.dataSource.data, event.previousIndex, event.currentIndex);

    this.dataSource.data = this.dataSource.data;
    this.updateValueMenu({ data: this.dataSource.data });
  }
  
}
